import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="border-y border-background-200/70 bg-background-100/50 scroll-mt-24">
      <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="CATEGORIES"
          title="六大复盘方向"
          description="按事件类型归档，方便你把同一类旧事集中看完，也更容易找到相似的处理逻辑。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((item) => (
            <Link
              key={item.id}
              to={`/archive?category=${item.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors duration-300 hover:border-accent-700/60 cursor-pointer"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-950 text-accent-400 transition-colors duration-300 group-hover:bg-primary-800 group-hover:text-foreground-950">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950">
                    {item.name}
                  </span>
                  <span className="shrink-0 text-xs text-foreground-500">{item.count} 篇</span>
                </span>
                <span className="mt-2 block text-xs leading-relaxed text-foreground-600">
                  {item.desc}
                </span>
                <span className="mt-3 flex items-center gap-1 text-xs text-accent-500">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}